import {
  MODAL_CREATE_CONTENT_GROUP,
  MODAL_MOVE_TO_FOLDER,
} from "fleet/constant/media-library";
import {
  CREATE_CONTENT_FOLDER_SUCCESS,
  MOVE_TO_CONTENT_FOLDER_SUCCESS,
} from "fleet/redux-store/content-folders/actions";
import {
  CREATE_CONTENT_GROUP_SUCCESS,
  EDIT_CONTENT_GROUP_SUCCESS,
} from "fleet/redux-store/content-groups/actions";
import { MEDIA_LIBRARY_ARCHIVE_SUCCESS } from "fleet/redux-store/media-library";
import reduceReducers from "reduce-reducers";
import {
  UPLOAD_USER_CONTENT,
  UPLOAD_USER_CONTENT_ERROR,
  UPLOAD_USER_CONTENT_S3,
  UPLOAD_USER_CONTENT_SUCCESS,
  EDIT_USER_CONTENT_SUCCESS,
} from "redux-store/user-contents/actions";

import {
  MEDIA_LIBRARY_CLOSE_MODAL,
  MEDIA_LIBRARY_OPEN_MODAL,
  MEDIA_LIBRARY_REDIRECT,
  MEDIA_LIBRARY_RESET_STATE,
  MEDIA_LIBRARY_SELECT,
} from "./actions";

const initialState = {
  visibleModal: null,
  isUploading: false,
  redirectTo: {
    folderId: null,
    shouldRedirect: false,
  },
  selected: [],
};

const apiSuccessActions = [
  CREATE_CONTENT_GROUP_SUCCESS,
  MEDIA_LIBRARY_ARCHIVE_SUCCESS,
  EDIT_USER_CONTENT_SUCCESS,
  EDIT_CONTENT_GROUP_SUCCESS,
];

function successReducer(state) {
  return {
    ...state,
    visibleModal: null,
    selected: [],
  };
}

function apiMessageReducer(state = initialState, action) {
  if (apiSuccessActions.includes(action.type)) {
    return successReducer(state);
  }

  return state;
}

function selectReducer(state = initialState, action) {
  switch (action.type) {
    case MEDIA_LIBRARY_SELECT:
      return {
        ...state,
        selected: action.payload.selected,
      };
    default:
      return state;
  }
}

function resetReducer(state = initialState, action) {
  switch (action.type) {
    case MEDIA_LIBRARY_RESET_STATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}

function uploadReducer(state = initialState, action) {
  const visibleModal =
    state.visibleModal === MODAL_CREATE_CONTENT_GROUP
      ? MODAL_CREATE_CONTENT_GROUP
      : null;

  switch (action.type) {
    case UPLOAD_USER_CONTENT:
    case UPLOAD_USER_CONTENT_S3:
      return {
        ...state,
        isUploading: true,
      };
    case UPLOAD_USER_CONTENT_ERROR:
      return {
        ...state,
        isUploading: false,
      };
    case UPLOAD_USER_CONTENT_SUCCESS:
      return {
        ...successReducer(state),
        ...{ visibleModal },
        isUploading: false,
      };
    default:
      return state;
  }
}

function redirectToFolderReducer(state, folderId) {
  return {
    ...state,
    visibleModal: null,
    redirectTo: {
      folderId,
      shouldRedirect: true,
    },
  };
}

function folderRedirectReducer(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case CREATE_CONTENT_FOLDER_SUCCESS:
      if (state.visibleModal === MODAL_MOVE_TO_FOLDER) {
        return state;
      }
      return redirectToFolderReducer(state, payload.data.id);

    case MEDIA_LIBRARY_REDIRECT:
    case MOVE_TO_CONTENT_FOLDER_SUCCESS:
      return redirectToFolderReducer(state, payload.data.id);

    default:
      return state;
  }
}

function modalReducer(state = initialState, action) {
  switch (action.type) {
    case MEDIA_LIBRARY_CLOSE_MODAL:
      return {
        ...state,
        visibleModal: null,
      };
    case MEDIA_LIBRARY_OPEN_MODAL:
      return {
        ...state,
        visibleModal: action.payload,
      };
    default:
      return state;
  }
}

const mediaLibraryReducer = reduceReducers(
  apiMessageReducer,
  folderRedirectReducer,
  modalReducer,
  resetReducer,
  selectReducer,
  uploadReducer,
);

export { mediaLibraryReducer };
